<template>
  <FormItemWrapper>
    <FormItemLabel slot="label">{{ $t('formItemLabelCustomerType') }}</FormItemLabel>
    <Tooltip
      v-if="$t('formItemTooltipCustomerType')"
      slot="tooltip"
      :content="$t('formItemTooltipCustomerType')"
    />
    <el-select
      v-model="customerType"
      :placeholder="$t('formItemCustomerTypePlaceholder')"
    >
      <el-option
        v-for="(item, index) in customerTypes"
        :key="`item-${index}`"
        :label="item.description[selectedLanguage]"
        :value="item.id"
      />
    </el-select>
  </FormItemWrapper>
</template>

<script>
import Vue from 'vue';
import { Select, Option } from 'element-ui';
// Components
import FormItemWrapper from '@/components/formItem/Wrapper.vue';
import FormItemLabel from '@/components/formItem/Label.vue';
import Tooltip from '@/components/Tooltip.vue';

Vue.use(Select);
Vue.use(Option);

export default {
  name: 'FilterCustomerType',
  components: {
    FormItemWrapper,
    FormItemLabel,
    Tooltip,
  },
  computed: {
    customerTypes() {
      return this.$store.state.filter.customerTypes;
    },
    customerType: {
      get() {
        return this.$store.state.filter.activeFilters.customerType;
      },
      set(value) {
        this.$store.commit('filter/SET_CUSTOMER_TYPE', value);
        this.$store.commit('filter/SET_METER_TYPE', 'double_rate_meter');
        this.$store.commit('filter/SET_CONSUMPTION_TYPE', true); // bilo false
        this.$store.commit('filter/SET_POWER_MEASUREMENT', 'with'); // / vratiti na without
      },
    },
    selectedLanguage() {
      return this.$i18n.locale();
    },
  },
};
</script>
